import { useContext } from "react"
import { ModeloIzzaGPTContext } from "./ModeloIzzaGPTContext"

export function useModeloIzzaGPTContext() {
    return useContext(ModeloIzzaGPTContext)
}
